import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "flex text-xl font-semibold text-gray-800" }
const _hoisted_3 = {
  key: 0,
  class: "mt-4 flex bg-gray-50 px-4 py-4 shadow ring-1 ring-gray-300 sm:p-6 md:rounded"
}
const _hoisted_4 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_5 = { class: "grid grid-cols-3 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiSpinner = _resolveComponent("UiSpinner")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiBadge = _resolveComponent("UiBadge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('report.realtime.title')) + " ", 1 /* TEXT */),
          ($setup.isLoading)
            ? (_openBlock(), _createBlock(_component_UiSpinner, {
                key: 0,
                class: "theme-color ml-2 h-6 w-6"
              }))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      actions: _withCtx(() => [
        _createVNode($setup["RealtimeReportFilters"])
      ]),
      _: 1 /* STABLE */
    }),
    ($setup.activeFilters.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activeFilters, (filter) => {
            return (_openBlock(), _createBlock(_component_UiBadge, {
              key: `${filter.field}_${filter.id}`,
              removable: "",
              onRemove: ($event: any) => ($setup.handleRemoveFilter(filter))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`report.realtime.filters.activeTag.${filter.field}`)) + ": " + _toDisplayString(filter.label), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onRemove"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["SummaryMetricsPanel"], { metrics: $setup.realtimeMetrics }, null, 8 /* PROPS */, ["metrics"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode($setup["QueueCallGaugeChart"], {
        queueCalls: $setup.queueCalls,
        class: "col-span-3 h-[200px] md:col-span-1 md:h-[277px]"
      }, null, 8 /* PROPS */, ["queueCalls"]),
      _createVNode($setup["QueueCallsTable"], {
        queueCalls: $setup.queueCalls,
        class: "col-span-3 h-[200px] md:col-span-2 md:h-[277px]"
      }, null, 8 /* PROPS */, ["queueCalls"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode($setup["UserDeviceStatusDoughnutChart"], {
        userDevices: $setup.userDevices,
        class: "col-span-3 h-[200px] md:col-span-1 md:h-[277px]"
      }, null, 8 /* PROPS */, ["userDevices"]),
      _createVNode($setup["UserDevicesTable"], {
        userDevices: $setup.userDevices,
        class: "col-span-3 h-[200px] md:col-span-2 md:h-[277px]"
      }, null, 8 /* PROPS */, ["userDevices"])
    ])
  ]))
}